/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { AboutVirdioPage } from "../pages/AboutVirdio";
import { AskMyraPage } from "../pages/AskMyra";
import { HowItWorksPage } from "../pages/HowItWorks";
import SelfAssessment2 from "./SelfAssessment";
import { LandingPage } from "../virdioHealth/LandingPage";
import { AboutUs } from "../virdioHealth/About";
import { ContactUs } from "../virdioHealth/ContactUs";
import { RegisterScreen, VerifyScreen, SubscriptionScreen, PaymentScreen, SettingsScreen, AccessQuestionnaireScreen, CareTeamScreen } from "./screens/AuthScreens";
import LbpNewLandingPage from "./screens/lbpNewLandingPage";
import { HipaaNoticeScreen, TermsScreen, PrivacyScreen } from "./screens/StaticPages";
import AccessAboutProgram from "./screens/access/AccessAboutProgram";
import AccessHowItWorks from "./screens/access/AccessHowItWorks";
import AccessWhatWeAskFor from "./screens/access/AccessWhatWeAskFor";
function AppRoutesInner() {
    const hostname = window.location.hostname;
    const isForcedHome = window.location.search.indexOf('homevirdiohealth') > 0;
    const RootComponent = hostname === "virdiohealth.com" || hostname === "www.virdiohealth.com" || isForcedHome ? LandingPage : SelfAssessment2;

    return (
        <>
            <Switch>
                <Route path="/" exact component={RootComponent} />
                <Route path="/intake/lower-back" exact component={RootComponent} />
                <Route path="/register" component={RegisterScreen} />
                <Route path="/verify" component={VerifyScreen} />
                <Route path="/subscription" component={SubscriptionScreen} />
                <Route path="/questionnaire" component={AccessQuestionnaireScreen} />
                <Route path="/care-team" component={CareTeamScreen} />

                <Route path="/payment" component={PaymentScreen} />
                <Route path="/settings" component={SettingsScreen} />
                <Route path="/ask-myra" component={AskMyraPage} />
                <Route path="/how-it-works" component={HowItWorksPage} />
                <Route path="/about" component={AboutVirdioPage} />
                <Route path="/about-us" component={AboutUs} />
                <Route path="/contact-us" component={ContactUs} />
                <Route path="/lbp-landing-page" exact component={LbpNewLandingPage} />
                <Route path="/access" exact component={LbpNewLandingPage} />
                <Route path="/access/lbp" exact component={LbpNewLandingPage} />
                <Route path="/access/lbp/about-the-access-program" component={AccessAboutProgram} />
                <Route path="/access/lbp/how-it-works" component={AccessHowItWorks} />
                <Route path="/access/lbp/what-we-ask-for" component={AccessWhatWeAskFor} />
                <Route path="/terms" exact component={TermsScreen} />
                <Route path="/privacy" exact component={PrivacyScreen} />
                <Route path="/hipaa-notice" exact component={HipaaNoticeScreen} />

            </Switch>
        </>
    );
}
export default function AppRoutesV2() {
    return (
        <Router>
            <AppRoutesInner />
        </Router>
    );
}
